import { SvgIconProps } from '@mui/material';

export default function LocationOnIcon(props: SvgIconProps & { fill?: string }) {
  const { fill, height, width } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || `24px`}
      height={height || `24px`}
      viewBox="0 0 14 14"
      fill={fill || `#2E3744`}
    >
      <path
        d="M7.0002 0.889526C5.64415 0.889526 4.34364 1.34939 3.38477 2.16797C2.4259 2.98654 1.88721 4.09676 1.88721 5.25439C1.88721 9.33117 6.4889 12.8536 6.66275 13.002C6.75605 13.072 6.876 13.1106 7.0002 13.1106C7.1244 13.1106 7.24435 13.072 7.33766 13.002C7.53707 12.8536 12.1132 9.33117 12.1132 5.25439C12.1132 4.68119 11.9809 4.1136 11.724 3.58403C11.467 3.05446 11.0904 2.57328 10.6156 2.16797C10.1409 1.76265 9.5772 1.44114 8.95686 1.22178C8.33652 1.00243 7.67165 0.889526 7.0002 0.889526ZM7.0002 12.0723C5.9776 11.1993 2.90981 8.33162 2.90981 5.25439C2.90981 4.32828 3.34076 3.44011 4.10786 2.78525C4.87495 2.13039 5.91536 1.7625 7.0002 1.7625C8.08504 1.7625 9.12545 2.13039 9.89255 2.78525C10.6596 3.44011 11.0906 4.32828 11.0906 5.25439C11.0906 8.30979 8.0228 11.1862 7.0002 12.0723Z"
        fill={fill ? fill : `#2E3744`}
      />
      <path
        d="M3.30224 8.73497C3.76005 9.57499 5.63974 11.651 6.93054 12.5721C7.9894 11.903 9.97791 9.5994 10.58 8.80697C11.3327 7.81644 11.5272 5.9749 11.5272 4.35336C11.5272 3.07083 8.73646 1.25879 6.93054 1.25879C5.09751 1.25879 2.60675 3.02283 2.37441 4.35336C2.19669 5.37112 2.94942 8.0876 3.30224 8.73497Z"
        fill={fill ? fill : `#2E3744`}
      />
      <path
        d="M4.77733 5.56423C5.93765 5.56423 6.87859 6.49321 6.87859 7.6388C6.94429 7.70946 7.05691 7.70946 7.12144 7.6388C7.12144 6.49321 8.06237 5.56423 9.22269 5.56423C9.29426 5.49937 9.29426 5.38817 9.22269 5.32446C8.06237 5.32446 7.12144 4.39548 7.12144 3.24989C7.05574 3.17923 6.94311 3.17923 6.87859 3.24989C6.87859 4.39548 5.93765 5.32446 4.77733 5.32446C4.70576 5.38932 4.70576 5.50052 4.77733 5.56423Z"
        fill="#FAFAFA"
      />
    </svg>
  );
}
